import DefaultLayout from 'src/components/Layout/Default';
import withLayout from 'src/components/Layout/WithLayout';
import {
    GaasEligibilityPage
} from '@gaas/gaas-react-component-library';

// this is using the eligibility page from the library and should be used where we are using a standard projectArchetype
// a different page template should be provided if no project archetype is used.

export default withLayout(GaasEligibilityPage, DefaultLayout);
